import { lazy } from 'react'

// -------

import { routes } from 'config/app'
import { Rules } from 'config/permissions'

const ListPage = lazy(() => import('./List'))
const FormPage = lazy(() => import('./Form'))

// -------

const route = routes.baseAdminRoute + '/companies'

// -------

export const Api = {
  companies    : '/companies',
  company      : '/companies/:id',
  companyDownloadPdfHeader: '/companies/:id/download-pdf-header',
}

export const Routes = {
  index: route,
  form: `${route}/:id`
}

// COMPONENTS
export const Components = [
  { path: Routes.index, component: ListPage, permission: Rules.page.company.index },
  { path: Routes.form,  component: FormPage, permission: Rules.page.company.index }
]

